import React, { Component } from 'react';

import { urlRegex } from 'validate';

import Button from 'components/ui-components/button';
import Input from 'components/ui-components/input';

import './styles.less';

class LinkAttachmentForm extends Component {
  state = {
    attachmentUrl: '',
    error: null,
  };

  render() {
    const { attachmentUrl } = this.state;
    const inputSeverity = this.state.error != null ? 'error' : '';

    return (
      <div
        className={`link-attachment-form ${
          this.state.error ? 'has-error' : ''
        }`}
      >
        <Input
          onChange={url => this.setState({ attachmentUrl: url })}
          onEnter={this.handleSumbitLink}
          inputClass="new-style"
          fieldLabel="Paste in https://..."
          fieldType="text"
          fieldValue={attachmentUrl}
          severity={inputSeverity}
          status={this.state.error}
        />
        <Button
          buttonType="rp-primary-4"
          onClicked={this.handleSumbitLink}
          value="Save"
        />
      </div>
    );
  }

  handleSumbitLink = e => {
    const { attachmentUrl } = this.state;

    if (!urlRegex({ exact: true, strict: false }).test(attachmentUrl)) {
      return this.setState({ error: 'Yikes! Doesn’t look like a valid URL' });
    }

    this.props.createLinkAttachment(attachmentUrl);
    this.setState({ attachmentUrl: '' });
    e.target.blur();
  };
}

export default LinkAttachmentForm;
